import { render, staticRenderFns } from "./MaterielPriceList.vue?vue&type=template&id=d90b5682&scoped=true"
import script from "./MaterielPriceList.vue?vue&type=script&lang=js"
export * from "./MaterielPriceList.vue?vue&type=script&lang=js"
import style0 from "./MaterielPriceList.vue?vue&type=style&index=0&id=d90b5682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90b5682",
  null
  
)

export default component.exports